module.exports = __webpack_public_path__ + "img/header_logo.032509aa.png";